module.exports = __webpack_public_path__ + "static/media/akhandeswar-swami.9eb0424f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/akhandeswar-swami.jpeg
// module id = 534
// module chunks = 0